import { defineMessages } from 'react-intl';

/** The texts of "YouTube extras" (design service-extras a1, a2). Manual publish only. */
export const youtubeExtrasMessages = defineMessages({
  label: { id: 'app.sml.servicesPanel.youtubeExtras.label', defaultMessage: 'YouTube extras' },
  fullVideos: { id: 'app.sml.servicesPanel.youtubeExtras.fullVideos', defaultMessage: 'Full videos' },
  notConnected: {
    id: 'app.sml.servicesPanel.youtubeExtras.notConnected',
    defaultMessage: 'Connect your YouTube channel. Then MUSIC24 can put your full videos on it.',
  },
  noVideo: {
    id: 'app.sml.servicesPanel.youtubeExtras.noVideo',
    defaultMessage: 'No music video yet. Make one in the Studio: {credits} credits, Pro plan.',
  },
  making: { id: 'app.sml.servicesPanel.youtubeExtras.making', defaultMessage: 'Rendering.' },
  makingPart: {
    id: 'app.sml.servicesPanel.youtubeExtras.makingPart',
    defaultMessage: 'Rendering part {current} of {total}.',
  },
  waiting: {
    id: 'app.sml.servicesPanel.youtubeExtras.waiting',
    defaultMessage: 'MUSIC24 uploads it to YouTube when it is ready.',
  },
  renderFailed: {
    id: 'app.sml.servicesPanel.youtubeExtras.renderFailed',
    defaultMessage: 'The video did not render. Make it again in the Studio.',
  },
  ready: {
    id: 'app.sml.servicesPanel.youtubeExtras.ready',
    defaultMessage: 'Ready: revision {revision}, {length}, {width} x {height}.',
  },
  readyShort: { id: 'app.sml.servicesPanel.youtubeExtras.readyShort', defaultMessage: 'Ready: revision {revision}.' },
  readyNotConnected: {
    id: 'app.sml.servicesPanel.youtubeExtras.readyNotConnected',
    defaultMessage: 'Ready. Connect YouTube to upload it.',
  },
  uploading: {
    id: 'app.sml.servicesPanel.youtubeExtras.uploading',
    defaultMessage: 'MUSIC24 sends the video to YouTube. You can leave this page.',
  },
  scheduled: {
    id: 'app.sml.servicesPanel.youtubeExtras.scheduled',
    defaultMessage: 'Private on YouTube now. Public on {date} at {time}.',
  },
  scheduledNoTime: {
    id: 'app.sml.servicesPanel.youtubeExtras.scheduledNoTime',
    defaultMessage: 'Private on YouTube now.',
  },
  live: { id: 'app.sml.servicesPanel.youtubeExtras.live', defaultMessage: '{link} · public' },
  linked: { id: 'app.sml.servicesPanel.youtubeExtras.linked', defaultMessage: 'Added from your YouTube channel.' },
  newer: { id: 'app.sml.servicesPanel.youtubeExtras.newer', defaultMessage: 'Revision {revision} is ready.' },
  failed: {
    id: 'app.sml.servicesPanel.youtubeExtras.failed',
    defaultMessage: 'The YouTube upload did not finish.',
  },
  failedRefused: {
    id: 'app.sml.servicesPanel.youtubeExtras.failedRefused',
    defaultMessage: 'YouTube refused the video.',
  },
  failedFileGone: {
    id: 'app.sml.servicesPanel.youtubeExtras.failedFileGone',
    defaultMessage: 'The file of this video is gone. Make the video again.',
  },
  reconnect: {
    id: 'app.sml.servicesPanel.youtubeExtras.reconnect',
    defaultMessage: 'The YouTube sign-in ended. Reconnect to upload.',
  },
  removed: { id: 'app.sml.servicesPanel.youtubeExtras.removed', defaultMessage: 'YouTube no longer has this video.' },
  removedPrivate: {
    id: 'app.sml.servicesPanel.youtubeExtras.removedPrivate',
    defaultMessage: 'The video is private on YouTube now.',
  },
  chipRendering: { id: 'app.sml.servicesPanel.youtubeExtras.chip.rendering', defaultMessage: 'Rendering {progress}%' },
  chipGoesUp: { id: 'app.sml.servicesPanel.youtubeExtras.chip.goesUp', defaultMessage: 'Goes to YouTube' },
  chipUploading: { id: 'app.sml.servicesPanel.youtubeExtras.chip.uploading', defaultMessage: 'Uploading' },
  chipPublicAt: { id: 'app.sml.servicesPanel.youtubeExtras.chip.publicAt', defaultMessage: 'Public {date}' },
  chipScheduled: { id: 'app.sml.servicesPanel.youtubeExtras.chip.scheduled', defaultMessage: 'Scheduled' },
  chipOnYouTube: { id: 'app.sml.servicesPanel.youtubeExtras.chip.onYouTube', defaultMessage: 'On YouTube' },
  chipPrivate: { id: 'app.sml.servicesPanel.youtubeExtras.chip.private', defaultMessage: 'Private' },
  chipFailed: { id: 'app.sml.servicesPanel.youtubeExtras.chip.failed', defaultMessage: 'Failed' },
  chipReconnect: { id: 'app.sml.servicesPanel.youtubeExtras.chip.reconnect', defaultMessage: 'Reconnect' },
  chipRemoved: { id: 'app.sml.servicesPanel.youtubeExtras.chip.removed', defaultMessage: 'Removed' },
  chipNotMade: { id: 'app.sml.servicesPanel.youtubeExtras.chip.notMade', defaultMessage: 'Not made' },
  actionConnect: { id: 'app.sml.servicesPanel.youtubeExtras.action.connect', defaultMessage: 'Connect YouTube' },
  actionReconnect: { id: 'app.sml.servicesPanel.youtubeExtras.action.reconnect', defaultMessage: 'Reconnect' },
  actionMakeIt: { id: 'app.sml.servicesPanel.youtubeExtras.action.makeIt', defaultMessage: 'Make it' },
  actionUpload: { id: 'app.sml.servicesPanel.youtubeExtras.action.upload', defaultMessage: 'Upload to YouTube' },
  actionReplace: { id: 'app.sml.servicesPanel.youtubeExtras.action.replace', defaultMessage: 'Replace on YouTube' },
  actionRetry: { id: 'app.sml.servicesPanel.youtubeExtras.action.retry', defaultMessage: 'Try again' },
  actionUploadAgain: { id: 'app.sml.servicesPanel.youtubeExtras.action.uploadAgain', defaultMessage: 'Upload again' },
  actionStatus: { id: 'app.sml.servicesPanel.youtubeExtras.action.status', defaultMessage: 'Status' },
  actionChangeTime: { id: 'app.sml.servicesPanel.youtubeExtras.action.changeTime', defaultMessage: 'Change time' },
  actionOpen: { id: 'app.sml.servicesPanel.youtubeExtras.action.open', defaultMessage: 'Open' },
});
